const entrypointUri = process.env.REACT_APP_360SC_BACKOFFICE_URI_ENTRYPOINT;

const redirectToUserPage = (companyId: string | null) => {
    if (!companyId) return;
    const url = `${entrypointUri}/#/app/users?filter[wcCompanyId=${companyId}]`;
    window.open(url);
};
export { redirectToUserPage };
